import React from 'react';

const TimelineNotepadIcon = ({ fill = 'grey' }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 13 17.2"
      xmlSpace="preserve"
      fill={fill}
      className="card-icon"
    >
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New" fill={fill}>
        <g id="Case-Details---Timeline" transform="translate(-580.000000, -904.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Case-Created">
                <g id="Icon" transform="translate(31.000000, 0.000000)">
                  <g id="Avatar">
                    <path
                      id="Shape"
                      fill={fill}
                      d="M26.5,28.1h-3.8c-0.1,0-0.3,0.1-0.3,0.3v0.5c0,0.1,0.1,0.3,0.3,0.3h3.8
                      c0.1,0,0.3-0.1,0.3-0.3v-0.5C26.8,28.2,26.6,28.1,26.5,28.1z M26.5,31.3h-3.8c-0.1,0-0.3,0.1-0.3,0.3v0.5
                      c0,0.1,0.1,0.3,0.3,0.3h3.8c0.1,0,0.3-0.1,0.3-0.3v-0.5C26.8,31.4,26.6,31.3,26.5,31.3z M20.8,27.8c-0.5,0-0.8,0.4-0.8,0.8
                      c0,0.4,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8C21.6,28.2,21.2,27.8,20.8,27.8z M20.8,31c-0.5,0-0.8,0.4-0.8,0.8s0.4,0.8,0.8,0.8
                      s0.8-0.4,0.8-0.8S21.2,31,20.8,31z M28.4,22.2h-3c0-0.1,0-0.2,0-0.3c0-1-0.8-1.9-1.9-1.9s-1.9,0.8-1.9,1.9c0,0.1,0,0.2,0,0.3
                      h-3c-0.9,0-1.6,0.7-1.6,1.6v11.8c0,0.9,0.7,1.6,1.6,1.6h9.8c0.9,0,1.6-0.7,1.6-1.6V23.8C30,22.9,29.3,22.2,28.4,22.2z
                      M23.5,21.1c0.5,0,0.8,0.4,0.8,0.8s-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8S23,21.1,23.5,21.1z M28.9,35.6c0,0.3-0.2,0.5-0.5,0.5
                      h-9.8c-0.3,0-0.5-0.2-0.5-0.5V23.8c0-0.3,0.2-0.5,0.5-0.5h1.6v0.7c0,0.2,0.2,0.4,0.4,0.4h5.7c0.2,0,0.4-0.2,0.4-0.4v-0.7h1.6
                      c0.3,0,0.5,0.2,0.5,0.5V35.6z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineNotepadIcon;
